const typographyCompleteActionModal = {
  post: 'Write your post:',
  file: 'Attach Files'
};

export default typographyCompleteActionModal;
